(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media--variants"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wh-desktop-thumb-nav')) {
    customElements.define('wh-desktop-thumb-nav', class extends HTMLElement {
      connectedCallback() {
        this.wrapper = this.parentElement.querySelector('.product-media--thumbs-wrapper');
        this.buttons = Array.from(this.querySelectorAll('button'));
        if (!this.wrapper || this.buttons.length !== 2) return;
        this.desktop = window.matchMedia('(min-width: 768px)');
        this.configure = () => {
          this.controller?.abort();
          this.observer?.disconnect();
          this.hidden = true;
          if (!this.desktop.matches) return;
          this.controller = new AbortController();
          const signal = this.controller.signal;
          const update = () => {
            const max = this.wrapper.scrollWidth - this.wrapper.clientWidth;
            const horizontal = getComputedStyle(this.wrapper).flexDirection === 'row';
            this.hidden = !horizontal || max <= 1;
            this.buttons[0].disabled = this.wrapper.scrollLeft <= 1;
            this.buttons[1].disabled = this.wrapper.scrollLeft >= max - 1;
          };
          this.buttons.forEach(button => button.addEventListener('click', () => {
            const direction = Number(button.dataset.direction);
            const distance = Math.max(68, this.wrapper.clientWidth - 80);
            this.wrapper.scrollBy({
              left: direction * distance,
              behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
            });
          }, { signal }));
          this.wrapper.addEventListener('scroll', update, { passive: true, signal });
          this.observer = new ResizeObserver(update);
          this.observer.observe(this.wrapper);
          update();
        };
        this.desktop.addEventListener('change', this.configure);
        this.configure();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.desktop?.removeEventListener('change', this.configure);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
